import { render, staticRenderFns } from "./UcInvoiceViewDocumentDropdown.yaml?vue&type=template&id=0ca0cb86&component"
import script from "./UcInvoiceViewDocumentDropdown.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceViewDocumentDropdown.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports